import { render, staticRenderFns } from "./VehicleDevicesItemComponent.vue?vue&type=template&id=f1b54c10&scoped=true&"
import script from "./VehicleDevicesItemComponent.vue?vue&type=script&lang=ts&"
export * from "./VehicleDevicesItemComponent.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleDevicesItemComponent.vue?vue&type=style&index=0&id=f1b54c10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1b54c10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
